export const PRODUCT_VARIANTS_FEATURE = "productVariants";
export const PRODUCT_VARIANTS_PERMISSION = "feature:ActivateProductVariants";

// pedidos-whatsapp: todo tipo distinto de `single` trae variantes y es de la
// feature de plan `productVariants` (desde Starter).
export const typeRequiresVariants = (type) => type !== "single";

export const productTypes = {
    article: "Artículo",
    clothes: "Ropa",
    uniform: "Uniforme",
    food: "Alimento",
    commodity: "Mercancía",
    toy: "Figura",
    single: "Producto único",
    endowment: "Dotación",
    drink: "Bebida",
    alcohol: "Alcohol",
    harvest: "Cosecha",
    cigarettes: "Cigarrillos",
    adult: "Adultos",
    electronic: "Electrónico",
    book: "Libro",
    service: "Servicio",
    subscription: "Suscripción",
    review: "Reseña",
    custom1: "Personalizado 1",
    custom2: "Personalizado 2",
    custom3: "Personalizado 3",
    custom4: "Personalizado 4"
};

export const productTypeDescriptions = {
    article: {
        label: "Artículo",
        description:
            "Artículos con referencias personalizadas definidas libremente."
    },
    clothes: {
        label: "Ropa",
        description: "Prendas de vestir con tallas y colores."
    },
    food: {
        label: "Alimento",
        description: "Alimentos con diferentes presentaciones (peso, empaque)."
    },
    toy: {
        label: "Figura",
        description: "Juguetes con referencias personalizadas."
    },

    single: {
        label: "Producto único",
        description: "Producto sin variantes ni referencias adicionales."
    },
    commodity: {
        label: "Mercancía",
        description: "Mercancía a granel con diferentes presentaciones."
    },
    uniform: {
        label: "Uniforme",
        description: "Uniformes corporativos o escolares con tallas y colores."
    },
    endowment: {
        label: "Dotación",
        description: "Dotaciones de trabajo con tallas y colores."
    },
    drink: {
        label: "Bebida",
        description: "Bebidas no alcohólicas con tamaños y sabores."
    },
    alcohol: {
        label: "Alcohol",
        description: "Bebidas alcohólicas con tamaños y sabores."
    },
    harvest: {
        label: "Cosecha",
        description: "Productos agrícolas o de cosecha con presentaciones."
    },
    cigarettes: {
        label: "Cigarrillos",
        description: "Cigarrillos y tabaco con presentaciones y marcas."
    },
    adult: {
        label: "Adultos",
        description: "Productos para adultos con tamaños y variantes."
    },
    electronic: {
        label: "Electrónico",
        description:
            "Dispositivos y electrónicos con referencias personalizadas."
    },
    book: {
        label: "Libro",
        description: "Libros, revistas y material editorial. Sin variantes."
    },
    service: {
        label: "Servicio",
        description: "Servicios prestados sin inventario físico ni variantes."
    },
    subscription: {
        label: "Suscripción",
        description: "Planes o suscripciones recurrentes sin variantes."
    },
    review: {
        label: "Reseña",
        description: "Productos de tipo reseña sin variantes."
    },
    custom1: {
        label: "Personalizado 1",
        description: "Tipo personalizado con referencias definidas libremente."
    },
    custom2: {
        label: "Personalizado 2",
        description: "Tipo personalizado con referencias definidas libremente."
    },
    custom3: {
        label: "Personalizado 3",
        description: "Tipo personalizado con referencias definidas libremente."
    },
    custom4: {
        label: "Personalizado 4",
        description: "Tipo personalizado con referencias definidas libremente."
    }
};

export const productTypesReferenceConfig = {
    article: {
        showSize: true,
        showColor: true,
        showCustomReference: true,
        sizeLabel: "Tamaño",
        sizeLabelPlural: "Tamaños",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    clothes: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Talla",
        sizeLabelPlural: "Tallas",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    uniform: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Talla",
        sizeLabelPlural: "Tallas",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    food: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "Sabor",
        colorLabelPlural: "Sabores"
    },
    toy: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    commodity: {
        showSize: true,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    single: {
        showSize: false,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    endowment: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Talla",
        sizeLabelPlural: "Tallas",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    drink: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "Sabor",
        colorLabelPlural: "Sabores"
    },
    alcohol: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "Sabor",
        colorLabelPlural: "Sabores"
    },
    harvest: {
        showSize: true,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "",
        colorLabelPlural: ""
    },
    cigarettes: {
        showSize: true,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "Presentación",
        sizeLabelPlural: "Presentaciones",
        colorLabel: "",
        colorLabelPlural: ""
    },
    adult: {
        showSize: true,
        showColor: true,
        showCustomReference: false,
        sizeLabel: "Talla",
        sizeLabelPlural: "Tallas",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    electronic: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "Modelo",
        sizeLabelPlural: "Modelos",
        colorLabel: "Color",
        colorLabelPlural: "Colores"
    },
    book: {
        showSize: false,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    service: {
        showSize: false,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    subscription: {
        showSize: false,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    review: {
        showSize: false,
        showColor: false,
        showCustomReference: false,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    custom1: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    custom2: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    custom3: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    },
    custom4: {
        showSize: false,
        showColor: false,
        showCustomReference: true,
        sizeLabel: "",
        sizeLabelPlural: "",
        colorLabel: "",
        colorLabelPlural: ""
    }
};

export function getVariantFields(typeId) {
    const config = productTypesReferenceConfig[typeId];
    if (!config) return [];

    const fields = [];
    if (config.colorLabel) fields.push(config.colorLabel);
    if (config.sizeLabel) fields.push(config.sizeLabel);
    if (config.showCustomReference) fields.push("Nombre personalizado");

    return fields;
}

export const ALL_PRODUCT_TYPE_OPTIONS = [
    {
        id: "article",
        label: "Artículo",
        icon: "📦",
        description: "Artículos con referencias personalizadas",
        variants: "Permite variantes de color/tamaño y nombre personalizado"
    },
    {
        id: "clothes",
        label: "Ropa",
        icon: "👗",
        description: "Prendas con variantes de talla y color",
        variants: "Permite variantes de color/talla"
    },
    {
        id: "uniform",
        label: "Uniforme",
        icon: "🦺",
        description: "Uniformes con tallas y colores",
        variants: "Permite variantes de color/talla"
    },
    {
        id: "endowment",
        label: "Dotación",
        icon: "🧤",
        description: "Dotaciones de trabajo con tallas y colores",
        variants: "Permite variantes de color/talla"
    },
    {
        id: "food",
        label: "Alimentos",
        icon: "🍱",
        description: "Alimentos con presentaciones y tamaños",
        variants: "Permite variantes de sabor/presentación"
    },
    {
        id: "drink",
        label: "Bebidas",
        icon: "🥤",
        description: "Bebidas con variantes de tamaño y sabor",
        variants: "Permite variantes de sabor/presentación"
    },
    {
        id: "alcohol",
        label: "Alcohol",
        icon: "🍷",
        description: "Bebidas alcohólicas con tamaños y presentaciones",
        variants: "Permite variantes de sabor/presentación"
    },
    {
        id: "commodity",
        label: "Mercancía",
        icon: "🏷️",
        description: "Mercancía a granel con diferentes presentaciones",
        variants: "Permite variantes de color/presentación"
    },
    {
        id: "harvest",
        label: "Cosecha",
        icon: "🌾",
        description: "Productos agrícolas con presentaciones por peso",
        variants: "Permite variantes de presentación"
    },
    {
        id: "cigarettes",
        label: "Cigarrillos",
        icon: "🚬",
        description: "Cigarrillos y tabaco con presentaciones",
        variants: "Permite variantes de presentación"
    },
    {
        id: "toy",
        label: "Figura",
        icon: "🧸",
        description: "Juguetes y figuras con referencias personalizadas",
        variants: "Permite variantes de nombre personalizado"
    },
    {
        id: "electronic",
        label: "Electrónico",
        icon: "💻",
        description: "Dispositivos y electrónicos con referencias",
        variants: "Permite variantes de color/modelo y nombre personalizado"
    },
    {
        id: "adult",
        label: "Adultos",
        icon: "🔞",
        description: "Productos para adultos con tamaños y variantes",
        variants: "Permite variantes de color/talla"
    },
    {
        id: "single",
        label: "Producto único",
        icon: "🎯",
        description: "Producto simple sin variantes adicionales",
        variants: "Sin variantes"
    },
    {
        id: "book",
        label: "Libro",
        icon: "📚",
        description: "Libros y material editorial, sin variantes",
        variants: "Sin variantes"
    },
    {
        id: "service",
        label: "Servicio",
        icon: "🛠️",
        description: "Servicios sin inventario físico ni variantes",
        variants: "Sin variantes"
    },
    {
        id: "subscription",
        label: "Suscripción",
        icon: "🔄",
        description: "Planes o suscripciones recurrentes",
        variants: "Sin variantes"
    },
    {
        id: "review",
        label: "Reseña",
        icon: "📝",
        description: "Productos de tipo reseña",
        variants: "Sin variantes"
    },
    {
        id: "custom1",
        label: "Personalizado 1",
        icon: "⚡",
        description: "Tipo personalizado con referencias libres",
        variants: "Permite variantes de nombre personalizado"
    },
    {
        id: "custom2",
        label: "Personalizado 2",
        icon: "⚡",
        description: "Tipo personalizado con referencias libres",
        variants: "Permite variantes de nombre personalizado"
    },
    {
        id: "custom3",
        label: "Personalizado 3",
        icon: "⚡",
        description: "Tipo personalizado con referencias libres",
        variants: "Permite variantes de nombre personalizado"
    },
    {
        id: "custom4",
        label: "Personalizado 4",
        icon: "⚡",
        description: "Tipo personalizado con referencias libres",
        variants: "Permite variantes de nombre personalizado"
    }
];
